import moment from 'moment-timezone';
import getMomentLocale from './preferredLocaleMoment';

let nuskinHQ = {
    timezone: "US/Mountain",
    toHQTime: function(datetime) {
        datetime || (datetime = moment());
        return moment.tz(datetime, this.timezone);
    },
    fromHQTime: function(datetime) {
        var datetime = moment.tz(moment(), this.timezone);
    }
};

let dateFormatter = {

    currentLocale: "en",
    formats: {
        defaultDate: "MMM DD, YYYY",
        simpleDate: "MMMM DD, YYYY",
        simpleTime: "h:mma",
        localizedDate: "L",
        monthDayYearDate: 'MM/DD/YYYY HH:mm:ss',
        militaryDate: 'DDMMMYYYY'
    },

    setLocale: function(locale) {
        locale = locale || this.currentLocale || "en";
        moment.locale(getMomentLocale(locale));
    },
    format: function(date, locale) {
        this.setLocale(locale);
        return moment(date).format(this.formats.defaultDate);
    },
    simpleDate: function(date, options) {
        return moment(date).format(this.formats.simpleDate);
    },
    simpleTime: function(date, options) {
        options || (options = {});
        let asMoment = moment(date),
            now			 = moment(),
            format   = "";

        if(!now.isSame(asMoment, "day")) {
            format = format + this.formats.simpleDate;
        }

        format = format + " " + this.formats.simpleTime;

        if(options.timezone) {
            format = format + " (z)";
        }
        return moment(date).format(format);
    },
    fromNow: function(date, locale) {
        this.setLocale(locale);
        return moment(date).fromNow();
    },
    toHQTime: function(datetime) {
        return nuskinHQ.toHQTime(datetime);
    },
    getFriendlyHQDate: function(datetime) {
        let date = this.toHQTime(datetime);
        return this.simpleDate(date);
    },
    getFriendlyHQTime: function(datetime) {
        let date = this.toHQTime(datetime);
        return this.simpleTime(date, { timezone: true });
    },
    getCountryFormattedDate: function(datetime, locale) {
        this.setLocale(locale);
        return moment(datetime).format(this.formats.localizedDate);
    },
    getMonthDayYearFormattedDate: function(datetime){
        return moment(datetime).format(this.formats.monthDayYearDate);
    },
    getMilitaryFormattedDate: function(datetime, locale){
        this.setLocale(locale);
        return moment(datetime).format(this.formats.militaryDate);
    },
    toHQTimeEndOfDay: function (datetime) {
        return this.toHQTime(datetime).endOf('day');
    },
    toHQTimeStartOfDay: function (datetime) {
        return this.toHQTime(datetime).startOf('day');
    }
};

export default dateFormatter;
